module.exports = __webpack_public_path__ + "images/emoji/kissing_cat.62e91f794608015a98a2.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/kissing_cat.png
// module id = 9EMn
// module chunks = 13